export default __webpack_public_path__ + "static/media/price-tag.414e5e9b.png";